module.exports = __webpack_public_path__ + "static/media/tel-bill.914aba7e.png";